/*
 * Copyright (c) 2021. FINN Sp. z o.o.
 */

package pl.finn.forms.model

import io.kvision.core.VerticalAlign
import io.kvision.html.*
import io.kvision.modal.Alert
import io.kvision.modal.Confirm
import io.kvision.table.*
import io.kvision.utils.px
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import pl.finn.forms.generator.DocumentFormModel
import pl.finn.forms.generator.FormStructure
import pl.finn.forms.utils.form.FormBuilder

class FormComponents() {

  fun createAttachmentsTable(state: FormStructure, reference: FormBuilder<DocumentTreeNode>): Div {

    return (
        Div {
          h6("Lista załączników do pisma", className = "mt-4")
          table(
            listOf("Nazwa pliku", "Opis załącznika", ""),
            setOf(TableType.HOVER, TableType.STRIPED, TableType.BORDERED, TableType.SMALL),
            responsiveType = ResponsiveType.RESPONSIVE
          ) {
            state.attachments?.forEach { attachment ->
              row {
                cell {
                  verticalAlign = VerticalAlign.MIDDLE
                  b(attachment.name)
                }
                cell {
                  verticalAlign = VerticalAlign.MIDDLE
                  attachment.description?.let {
                    div(it)
                  }
                }
                cell {
                  align = Align.CENTER
                  width = 150.px
                  button("Usuń załącznik", "fas fa-trash", ButtonStyle.DANGER) {
                    size = ButtonSize.SMALL
                    onClick {
                      reference.getData()
                      DocumentFormModel.removeAttachment(attachment.name)
                    }
                  }
                }
              }
            }
          }
        }
        )
  }

  val format = Json { ignoreUnknownKeys = true }

  fun createButtonPanel(state: FormStructure, reference: FormBuilder<DocumentTreeNode>): Div {

    return (
        Div(className = "form-group my-3") {
          div(className = "row") {
            div(className = "col-lg-6") {
              div(className = "row") {
                div(className = "col-sm-6 py-2") {
                  button(
                    "Zapisz dokument",
                    "far fa-save fa-3x d-block",
                    ButtonStyle.SUCCESS, className = "w-100"
                  ).onClick {
                    reference.getData()
                    if (!reference.validate()) DocumentFormModel.openValidationMessageDialog()
                    else DocumentFormModel.saveForm(null)
                  }
                }
                div(className = "col-sm-6 py-2") {
                  button("Sprawdź dokument", "fas fa-tasks fa-3x d-block", className = "w-100").onClick {
                    val isValidated = reference.validate()
                    if (isValidated) {
                      Alert.show(
                        "Sprawdzenie dokumentu",
                        "Dokument jest poprawny.<br/>Wszystkie pola wypełnione są prawidłowo.",
                        rich = true
                      )
                    } else {
                      Alert.show(
                        "Sprawdzenie dokumentu",
                        "Dokument zawiera niepoprawne dane.<br/>Należy poprawić pola oznaczone na czerwono.",
                        rich = true
                      )
                    }
                  }
                }
              }
            }
            div(className = "col-lg-6") {
              div(className = "row") {
                div(className = "col-sm-6 py-2") {
                  button("Podgląd dokumentu", "fas fa-eye fa-3x d-block", className = "w-100").onClick {
                    reference.getData()
                    DocumentFormModel.previewForm(this)
//                    val jsonData = format.encodeToString(state.elements)
//                    println(jsonData)
                  }
                }
                div(className = "col-sm-6 py-2") {
                  button(
                    "Anuluj",
                    "fas fa-times fa-3x d-block",
                    ButtonStyle.SECONDARY, className = "w-100"
                  ).onClick {
                    Confirm.show(
                      "Potwierdzenie",
                      "Czy anulować edycję formularza i powrócić do poprzedniej strony?",
                      yesTitle = "Tak",
                      noTitle = "Nie"
                    ) {
                      DocumentFormModel.cancel()
                    }
                  }
                }
              }
            }
          }
        }
        )
  }

}
